import { IOmniaSession, IOmniaSettings, ISoilUnitConfig, ISoilUnitService, SoilUnit } from "../omnia"

/// <reference path="../types.ts" />

export class SoilUnitService implements ISoilUnitService {

    static $inject = ["OmniaSession", "omniaSoilUnitConfig"];

    private settings: IOmniaSettings;

    private _soil: SoilUnit;
    private _nitrogen: SoilUnit;

    constructor(private session: IOmniaSession, private config: ISoilUnitConfig) {
        this.restoreSettings();
    }

    private restoreSettings() {

        this.settings = this.session.getSettings("soilanalysis.units");

        this.config.soil = this._soil = this.settings.get("soil", SoilUnit.Ppm);
        this.config.nitrogen = this._nitrogen = this.settings.get("nitrogen", SoilUnit.KgHa)

    }

    get soil(): SoilUnit {
        return this._soil;
    }

    set soil(value: SoilUnit) {
        this._soil = this.setValue(value, "soil");
    }

    get nitrogen(): SoilUnit {
        return this._nitrogen;
    }

    set nitrogen(value: SoilUnit) {
        this._nitrogen = this.setValue(value, "nitrogen");
    }

    private setValue(value: SoilUnit, key: string) {
        this.config[key] = value;
        this.settings.set(key, value);
        return value;
    }

}
